import React from "react";
import PropTypes from "prop-types";
import RenderBullet from "../../../components/atoms/RenderBullet/RenderBullet";

const DiseaseColumn = ({ disease, phenotypes }) => {
  return (
    <>
      {disease}
      {phenotypes && phenotypes.length > 0 && (
        <div>
          <strong>Phenotypes</strong>
          <div>
            {phenotypes.map((phenotype, i) => {
              return (
                <div className="tw-mb-0" key={i}>
                  <RenderBullet />
                  {phenotype}
                </div>
              );
            })}
          </div>
          <br />
        </div>
      )}
    </>
  );
};

DiseaseColumn.propTypes = {
  disease: PropTypes.string,
  phenotypes: PropTypes.arrayOf(PropTypes.string),
};

DiseaseColumn.defaultProps = {
  disease: "",
  phenotypes: [],
};

export default DiseaseColumn;
